var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-popover",
        {
          attrs: { placemen: "bottom", trigger: "manual" },
          model: {
            value: _vm.visible,
            callback: function($$v) {
              _vm.visible = $$v
            },
            expression: "visible"
          }
        },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: { slot: "reference", filterable: "" },
              on: {
                change: _vm.accountTitleChangeHandler,
                "visible-change": _vm.onVisibleChange
              },
              slot: "reference",
              model: {
                value: _vm.value,
                callback: function($$v) {
                  _vm.value = $$v
                },
                expression: "value"
              }
            },
            _vm._l(_vm.params.accountTitles, function(item) {
              return _c("el-option", {
                key: item.uuid,
                attrs: {
                  label: item.accountTitle + " " + item.accountTitleName,
                  value: item.accountTitle
                }
              })
            }),
            1
          ),
          _vm.accountTitleVisible
            ? _c(
                "el-form",
                { attrs: { "label-width": "60px" } },
                [
                  _vm.accountTitle.auxiliaryCustomer
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("FinanceManage.Client") } },
                        [
                          _c("cargo-advance-select", {
                            ref: "customerSelect",
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "callback-method-type": "value",
                              "default-value": _vm.form.auxiliaryCustomer
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.auxiliaryCustomer = p
                                _vm.updateDataValue()
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.accountTitle.auxiliarySupplier
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("FinanceManage.Supplier") } },
                        [
                          _c("cargo-advance-select", {
                            ref: "supplierSelect",
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "callback-method-type": "value",
                              "default-value": _vm.form.auxiliarySupplier
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.auxiliarySupplier = p
                                _vm.updateDataValue()
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.accountTitle.auxiliaryDepartment
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("FinanceManage.Department") }
                        },
                        [
                          _c("cargo-advance-select", {
                            ref: "departmentSelect",
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Department,
                              "callback-method-type": "value",
                              "default-value": _vm.form.auxiliaryDepartment,
                              "method-params": {
                                officeUuid: _vm.$store.getters.currentOfficeUuid
                              }
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.auxiliaryDepartment = p
                                _vm.updateDataValue()
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.accountTitle.auxiliarySales
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("FinanceManage.Staff") } },
                        [
                          _c("cargo-advance-select", {
                            ref: "salesSelect",
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_User,
                              "callback-method-type": "value",
                              "default-value": _vm.form.auxiliarySales,
                              cache: false,
                              "static-options": _vm.salesList
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.auxiliarySales = p
                                _vm.updateDataValue()
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.accountTitle.auxiliaryProjectNumber
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("FinanceManage.Project") } },
                        [
                          _c("el-input", {
                            on: { change: _vm.updateDataValue },
                            model: {
                              value: _vm.form.auxiliaryProject,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "auxiliaryProject", $$v)
                              },
                              expression: "form.auxiliaryProject"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }